








import Vue from 'vue';
import DocumentLink from '../../../../common/DocumentLink.vue';
export default Vue.extend({
    components: { DocumentLink },
    props: {
        documents: {
            type: Array,
            required: true,
        },
        moduleId: {
            type: String,
            required: true,
        },
        itemId: {
            type: ([Number, String] as unknown) as () => number | string,
            required: true,
        },
    },
});
